module.exports = __webpack_public_path__ + "img/clock.cb92cace.svg";